export default __webpack_public_path__ + "static/media/WebManualLogo.1dc56892.png";